import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=c79749c4"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"
import style0 from "./Sorting.vue?vue&type=style&index=0&id=c79749c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports